// utils/deviceIcons.js
import {
  FaWindows,
  FaApple,
  FaLinux,
  FaAndroid,
  FaChrome,
  FaFirefoxBrowser,
  FaSafari,
  FaEdge,
} from "react-icons/fa";
import { BsPhone, BsLaptop, BsGlobe } from "react-icons/bs";

export function getOsIcon(osType, size = 20) {
  const color = "#666";
  if (!osType) return <BsLaptop size={size} color={color} title="Unknown OS" />;
  const s = String(osType).toLowerCase();
  if (s.includes('win')) return <FaWindows size={size} color="#0078D6" title="Windows" />;
  if (s.includes('mac') || s.includes('darwin') || s.includes('os x')) return <FaApple size={size} color="#000000" title="macOS" />;
  if (s.includes('linux')) return <FaLinux size={size} color="#FCC624" title="Linux" />;
  if (s.includes('android')) return <FaAndroid size={size} color="#3DDC84" title="Android" />;
  if (s.includes('ios') || s.includes('iphone') || s.includes('ipad')) return <FaApple size={size} color="#000000" title="iOS" />;
  return <BsLaptop size={size} color={color} title={osType} />;
}

export function getBrowserIcon(browserType, size = 20) {
  const color = "#666";
  if (!browserType) return <BsGlobe size={size} color={color} title="Unknown Browser" />;
  const s = String(browserType).toLowerCase();
  if (s.includes('chrome') && !s.includes('edge')) return <FaChrome size={size} color="#4285F4" title="Chrome" />;
  if (s.includes('firefox')) return <FaFirefoxBrowser size={size} color="#FF7139" title="Firefox" />;
  if (s.includes('safari') && !s.includes('chrome')) return <FaSafari size={size} color="#1E90FF" title="Safari" />;
  if (s.includes('edge') || s.includes('edg/')) return <FaEdge size={size} color="#0A84FF" title="Edge" />;
  return <BsGlobe size={size} color={color} title={browserType} />;
}

export function getDeviceTypeIcon(deviceType, size = 20) {
  const color = "#666";
  if (!deviceType) return <BsLaptop size={size} color={color} title="Unknown Device" />;
  const s = String(deviceType).toLowerCase();
  if (s.includes('mobile') || s.includes('phone')) return <BsPhone size={size} color={color} title="Mobile" />;
  if (s.includes('tablet')) return <BsPhone size={size} color={color} title="Tablet" />;
  if (s.includes('desktop') || s.includes('pc') || s.includes('laptop')) return <BsLaptop size={size} color={color} title="Desktop" />;
  return <BsLaptop size={size} color={color} title={deviceType} />;
}

export function getOsDisplayName(osType) {
  if (!osType) return null;
  const s = String(osType).toLowerCase();
  if (s.includes('win')) return 'Windows';
  if (s.includes('mac') || s.includes('os x') || s.includes('darwin')) return 'macOS';
  if (s.includes('linux')) return 'Linux';
  if (s.includes('android') || s.includes('aosp')) return 'Android';
  if (s.includes('ios') || s.includes('iphone') || s.includes('ipad')) return 'iOS';
  return null;
}

export function getBrowserDisplayName(browserType) {
  if (!browserType) return null;
  const s = String(browserType).toLowerCase();
  if (s.includes('chrome') && !s.includes('edge')) return 'Chrome';
  if (s.includes('firefox')) return 'Firefox';
  if (s.includes('safari') && !s.includes('chrome')) return 'Safari';
  if (s.includes('edge') || s.includes('edg/')) return 'Edge';
  return null;
}

export function formatDeviceInfo(device) {
  const { device_type, os_name, os_type, browser_type, browser_version, ip, city, region, country } = device;
  
  console.log('🔍 Formatting device info:', { device_type, os_name, os_type, browser_type, ip, city, region, country });
  
  let deviceName = device_type || 'Unknown Device';
  // Build a combined string of available fields to better detect Android variants
  const combined = `${os_name || ''} ${os_type || ''} ${browser_type || ''} ${device_type || ''}`.trim();
  let osName = os_name || getOsDisplayName(combined) || getOsDisplayName(os_type) || 'Unknown OS';
  let browserName = getBrowserDisplayName(browser_type) || browser_type || 'Unknown Browser';

  // Country handling: if we only have ISO code, derive readable name via Intl.DisplayNames
  const countryCode = (country && typeof country === 'string' && country.length <= 3) ? country.toUpperCase() : null;
  let countryName = null;
  try {
    if (countryCode) {
      const regionNames = new Intl.DisplayNames(['en'], { type: 'region' });
      countryName = regionNames.of(countryCode) || null;
    }
  } catch (_) {
    // ignore Intl errors
  }
  
  if (browser_version) {
    browserName += ` ${browser_version}`;
  }
  
  let location = '';
  if (city && region) {
    location = `${city}, ${region}`;
  } else if (city) {
    location = city;
  } else if (region) {
    location = region;
  } else if (!countryCode && country) {
    // if country is a full name already
    location = country;
  }
  
  if (location && ip) {
    location += ` (${ip})`;
  } else if (ip) {
    location = ip;
  }
  
  return {
    deviceName,
    osName,
    browserName,
    location: location || 'Unknown Location',
    countryCode: countryCode || null,
    countryName: countryName || null
  };
}
